import { gql } from '@apollo/client';

import { cartPartial, subscriptionPartial } from '../partials';

export const applyCoupon = gql`
mutation ApplyCouponMutation($code: String!) {
  applyCoupon(input: {code: $code}) {
    ${cartPartial(subscriptionPartial)}
  }
}`;
